<div class="policy__item {{policy.selected}}">
  <div class="policy__item__container">
    <div class="policy__item__container__type">
      <img src="assets/icon/{{policy.section}}.svg"/>
    </div>
    <div class="policy__item__container__data">
     <div><strong>{{policy.plate}}</strong></div>
     <div>Cobertura {{policy.coverage_type}} <span *ngIf="policy.garage"> - Garage</span></div>
    </div>
  </div>
 
  <div *ngIf="policy.selected === 'selected'" class="policy__item__container__check">
    <img src="assets/icon/check.svg"/>
  </div>
</div>
